<template>
  <b-card no-body class="shadow flex-container grid-stack-item-content">
    <div slot="header">
      <window-header cmp-title="QA Helper" widget-name="qa_tool_info">
        <template slot="left-options">
          <span id="qa-wiki-link" @click="openWiki" v-b-tooltip.hover title='QA Wiki Link'><icon
            name="question-circle"></icon></span>
        </template>
      </window-header>
    </div>
    <div class="window-body qa-info-body flex-full-height">
      <div class='qa-helper-body-heading'>
        <icon name="question-circle" scale="2"></icon>
        <span>Suggestion</span>
      </div>
      <div class='suggestion-container'>
        <span class='suggestion-info'>{{suggestion}}</span>
      </div>
    </div>
    <window-footer></window-footer>
  </b-card>
</template>

<script>
  import WindowHeader from '../common/WindowHeader'
  import WindowFooter from '../common/WindowFooter'

  import stringSim from 'string-similarity'

  export default {
    name: 'ProjectQaInfo',
    components: {
      WindowHeader,
      WindowFooter
    },
    created () {
      this.wikiIndex = []
    },
    data () {
      return {
        suggestion: ''
      }
    },
    mounted () {
      this.loadWikiIndex()
      this.setSuggestion()
    },
    computed: {
      wikiProjectId: {
        get () {
          return this.$store.getters['project/wikiProjectId']
        },
        set (val) {
          this.$store.getters['project/wikiProjectId'] = val
        }
      },
      qaData () {
        return this.$store.getters['cmp/all']['qa_tool_info']['data']
      },
      qaDest () {
        return this.$store.getters['cmp/all']['qa_tool_info']['batch']
      },
      selectedQa () {
        return this.$store.getters['project/selectedQa']
      }
    },
    methods: {
      loadWikiIndex () {
        this.$http.get(`/api/redmine/projects/${this.wikiProjectId}/wiki/index.json`)
          .then(res => {
            this.wikiIndex = res.body.wiki_pages.map(p => p.title)
          }, e => {})
      },
      getBestpage (testName) {
        return stringSim.findBestMatch(testName, this.wikiIndex)
      },
      setDefaultSuggestion () {
        // TODO get suggestions from backend based on result OR calculate help result in service and pass to client
        let check = false
        if (this.qaData.length > 1) {
          let list = this.qaData.filter(q => q.batch_name == this.qaDest)
          check = list.find(c => c._rowVariant == 'danger' && (c.prio == 1 || c.prio == 2 || c.prio == 3))
        }
        if (check) {
          this.suggestion = 'Resolve categories with prio 1 to 3 ' +
            'using the designatron or polytron, ' +
            'before running backbone magic'
        } else {
          this.suggestion = 'For more details on a specific test ' +
            'click the qa wiki link button in the header of' +
            ' this help tool.'
          // this.suggestion = 'Most tests in QA categories with a prio ' +
          // 'greater than 3 will require the user to run backbone magic after' +
          // ' fixes.'
        }
      },
      setSuggestion (qaItem) {
        if (!qaItem) {
          this.setDefaultSuggestion()
        } else {
          if (!qaItem.children) {
            let bestPage = this.getBestpage(qaItem.testname)
            this.$http.get(`/api/redmine/projects/${this.wikiProjectId}/wiki/${bestPage.bestMatch.target}.json`)
              .then(res => {
                this.suggestion = res.body.wiki_page.text
              }, e => {
                this.setDefaultSuggestion()
              })
          } else {
            this.setDefaultSuggestion()
          }


        }

      },
      openWiki () {
        let win = window.open('/mine/projects/' + this.wikiProjectId + '/wiki/QA')
        win.focus()
      }
    },
    watch: {
      selectedQa (val) {
        val && this.setSuggestion(val)
      },
      qaData (val) {
        this.setSuggestion()
      },
      qaDest (val) {
        this.setSuggestion()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/QaTool_info.vue